import { render, staticRenderFns } from "./HelpCenterDownloads.vue?vue&type=template&id=77adc454"
import script from "./HelpCenterDownloads.vue?vue&type=script&lang=js"
export * from "./HelpCenterDownloads.vue?vue&type=script&lang=js"
import style0 from "./HelpCenterDownloads.vue?vue&type=style&index=0&id=77adc454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports